import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export interface IContentNotesGenerateRequest {
	transcriptContent: string;
	accountId: string;
	businessName: string;
	websiteUrl: string;
}

export interface IContentNotesGenerateResponse {
	htmlContent: string;
}

export function useAdminContentNotesGenerateMutation() {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: IContentNotesGenerateRequest) => {
			return userSession.webServiceHelper.callAsync<IContentNotesGenerateResponse>(
				'admin/zoom/transcripts/content-notes/generate',
				'POST',
				request
			);
		},
	});
}
